export const config = {
  apiBaseUrl: 'https://api.orderly.org',
  solana: {
    chainId: 900900900,
  },
  offChainDomain: {
    name: 'Orderly',
    version: '1',
    chainId: 0, // set at runtime from wallet
    verifyingContract: '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC' as const,
  },
  onChainDomain: {
    name: 'Orderly',
    version: '1',
    chainId: 0, // set at runtime from wallet
    verifyingContract: '0x6F7a338F2aA472838dEFD3283eB360d4Dff5D203' as const,
  },
};
